import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { NotFoundTestIds } from './sb-not-found.test-ids';

@Component({
  selector: 'app-not-found',
  imports: [MatButton, RouterLink],
  templateUrl: './sb-not-found.component.html'
})
/**
 *  SbNotFoundComponent-Klasse
 *  BEGRÜNDUNG: Noch kein Inhalt
 */
export class SbNotFoundComponent {
  protected readonly testIds = NotFoundTestIds;
}
